import { Attribution } from 'types'

interface Params {
  endDate: string
  startDate: string
  attr: Attribution
}

export const getTopDevices = ({ endDate, startDate, attr }: Params) => {
  const where = `WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}'`
  switch (attr) {
    case 'first':
      return `SELECT SUM(first.total_amount), SUM(first.recurring_payments_amount), SUM(first.orders_amount), SUM(stats.views), SUM(stats.new_visitors), SUM(first.leads), SUM(first.total_orders), SUM(first.new_customers), stats.device FROM page ${where} GROUP BY stats.device DESC LIMIT 5 OFFSET 0`
    case 'last':
      return `SELECT SUM(last.total_amount), SUM(last.recurring_payments_amount), SUM(last.orders_amount), SUM(stats.views), SUM(stats.new_visitors), SUM(last.leads), SUM(last.total_orders), SUM(last.new_customers), stats.device FROM page ${where} GROUP BY stats.device DESC LIMIT 5 OFFSET 0`
    case 'linear':
      return `SELECT SUM(linear_page.total_amount), SUM(linear_page.recurring_payments_amount), SUM(linear_page.orders_amount), SUM(stats.views), SUM(stats.new_visitors), SUM(linear_page.leads), SUM(linear_page.total_orders), SUM(stats.new_customers), stats.device FROM page ${where} GROUP BY stats.device DESC LIMIT 5 OFFSET 0`
    case 'ai':
      return `SELECT SUM(ai_page.total_amount), SUM(ai_page.recurring_payments_amount), SUM(ai_page.orders_amount), SUM(stats.views), SUM(stats.new_visitors), SUM(ai_page.leads), SUM(ai_page.total_orders), SUM(stats.new_customers), stats.device FROM page ${where} GROUP BY stats.device DESC LIMIT 5 OFFSET 0`
    default:
      return ''
  }
}
